// Simple locale -> currency mapping with approximate FX rates for DISPLAY only.
// Actual charging is done by Stripe adaptive_pricing at checkout in the user's local currency.

const CURRENCY_BY_REGION = {
  US: 'USD', CA: 'CAD', GB: 'GBP', AU: 'AUD', NZ: 'NZD', JP: 'JPY', IN: 'INR', BR: 'BRL', MX: 'MXN', CH: 'CHF',
  DE: 'EUR', FR: 'EUR', IT: 'EUR', ES: 'EUR', NL: 'EUR', IE: 'EUR', PT: 'EUR', BE: 'EUR', AT: 'EUR', FI: 'EUR',
  SE: 'SEK', NO: 'NOK', DK: 'DKK', PL: 'PLN', CZ: 'CZK', SG: 'SGD', HK: 'HKD', AE: 'AED', ZA: 'ZAR',
};

// Approximate FX rates from USD (indicative — Stripe uses live rates at checkout)
const RATE = { USD:1, EUR:0.92, GBP:0.79, CAD:1.36, AUD:1.52, NZD:1.64, JPY:155, INR:83, BRL:5.0, MXN:17.5, CHF:0.88, SEK:10.5, NOK:10.6, DKK:6.9, PLN:4.0, CZK:23, SGD:1.34, HKD:7.82, AED:3.67, ZAR:18.5 };

export const detectCurrency = () => {
  try {
    const loc = new Intl.Locale(navigator.language);
    const region = loc.region || (navigator.language.split('-')[1] || '').toUpperCase();
    return CURRENCY_BY_REGION[region] || 'USD';
  } catch (e) {
    return 'USD';
  }
};

export const formatPrice = (usdAmount, currency) => {
  const rate = RATE[currency] || 1;
  const value = usdAmount * rate;
  // Charm-price: round to .99 for most currencies
  const rounded = currency === 'JPY' || currency === 'INR' ? Math.round(value) : (Math.floor(value) + 0.99);
  try {
    return new Intl.NumberFormat(navigator.language, { style: 'currency', currency, maximumFractionDigits: currency === 'JPY' ? 0 : 2 }).format(rounded);
  } catch (e) {
    return `$${rounded.toFixed(2)}`;
  }
};
